import {
	RECEIVE_CLEAN_FORM,
	RECEIVE_EMAIL_DOMAIN_BLOCKED,
	RECEIVE_ERROR,
	RECEIVE_RECAPTCHA_TOKEN,
	RECEIVE_REDIRECT,
	RECEIVE_STEPS_COUNT,
	RECEIVE_SUBMIT_FORM,
	RECEIVE_USER_EXISTS,
	REQUEST_SUBMIT_FORM,
	UPDATE_FIELD,
	UPDATE_FORM,
	UPDATE_TO_PREV_STEP,
} from "./actions";

export function formReducer() {
	const initialState = {
		form: {},
		dirty: false,
		emailDomainBlocked: false,
		error: null,
		stepsCount: 5,
		loading: false,
		step: 0,
		success: false,
		recaptchaToken: null,
		redirect: false,
		userExists: false,
	};

	return function (state = initialState, action) {
		switch (action.type) {
			case UPDATE_FIELD: {
				const { fieldKey, value } = action.data;
				return Object.assign({}, state, {
					form: Object.assign({}, state.form, {
						[fieldKey]: value,
					}),
					dirty: true,
					emailDomainBlocked:
						fieldKey === "email" ? false : state.emailDomainBlocked,
				});
			}
			case UPDATE_FORM: {
				const lastStep = state.stepsCount - 1;
				const nextStep =
					state.step === lastStep ? state.step : state.step + 1;
				return Object.assign({}, state, {
					form: Object.assign({}, state.form, action.data),
					dirty: true,
					step: nextStep,
				});
			}
			case REQUEST_SUBMIT_FORM: {
				return Object.assign({}, state, {
					dirty: false,
					loading: true,
				});
			}
			case RECEIVE_CLEAN_FORM: {
				return Object.assign({}, state, {
					dirty: false,
				});
			}
			case RECEIVE_EMAIL_DOMAIN_BLOCKED: {
				return Object.assign({}, state, {
					emailDomainBlocked: action.data,
				});
			}
			case RECEIVE_SUBMIT_FORM: {
				return Object.assign({}, state, {
					loading: false,
					success: true,
				});
			}
			case RECEIVE_ERROR: {
				return Object.assign({}, state, {
					dirty: true,
					loading: false,
					error: action.data.error,
				});
			}
			case RECEIVE_RECAPTCHA_TOKEN: {
				return Object.assign({}, state, {
					recaptchaToken: action.data,
				});
			}
			case RECEIVE_REDIRECT: {
				return Object.assign({}, state, {
					redirect: true,
				});
			}
			case RECEIVE_STEPS_COUNT: {
				return Object.assign({}, state, {
					stepsCount: action.data,
				});
			}
			case RECEIVE_USER_EXISTS: {
				return Object.assign({}, state, {
					userExists: action.data,
				});
			}
			case UPDATE_TO_PREV_STEP: {
				return Object.assign({}, state, {
					step: state.step - 1,
				});
			}
			default:
				return state;
		}
	};
}
